var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{transparent: _vm.isBar}},[(!_vm.isBar)?_c('Header',{attrs:{"app-name":_vm.appName}}):_vm._e(),_c('v-main',[_c('div',{staticClass:"d-flex flex-column fill-height"},[_c('router-view'),(!_vm.isBar)?_c('Sponsor',{staticClass:"mt-auto"}):_vm._e()],1)]),(!_vm.isBar)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }